import { render, staticRenderFns } from "./GroupAddStore.vue?vue&type=template&id=3a60cab8"
import script from "./GroupAddStore.vue?vue&type=script&lang=js"
export * from "./GroupAddStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports